export enum PermissionResourcesCore {
	HYPERLINKS = "res://senior.com.br/analytics/hcm/resume/hyperlinks",
	HYPERLINKS_MANAGER = "res://senior.com.br/analytics/hcm/manager/resume/hyperlinks",
	MY_ANALYTICS = "res://senior.com.br/analytics/hcm/myAnalytics",
	ANALYTICS_TEAM = "res://senior.com.br/analytics/hcm/teamAnalytics"
	// RECRUITMENT_HR = "res://senior.com.br/hcm/recruitment/recruitmentDashboard",
	// REMUNERATION_HR = "res://senior.com.br/hcm/remuneration/dashboardRH",
	// PERFORMANCE_HR = "res://senior.com.br/analytics/hcm/hrPerformanceAnalytics",
	// CAREER_SUCCESSION_HR = "res://senior.com.br/analytics/hcm/hrCareerSuccessionAnalytics",
}

export enum PermissionResourcesModules {
	REMUNERATION = "res://senior.com.br/hcm/remuneration/remunerationManagement",
	RECRUITMENT = "res://senior.com.br/hcm/recruitment/menuRecruitmentManagement",
	APPOINTMENT = "res://senior.com.br/rh/ponto/gestaoponto/geral",
	MANAGEMENT_PANEL = "res://senior.com.br/analytics/hcm/module/managementDashboard",
	CAREER = "res://senior.com.br/analytics/hcm/module/careerAndSuccession",
	PERFORMANCE = "res://senior.com.br/analytics/hcm/module/performanceManagement",
	MOODS = "res://senior.com.br/hcm/moods/module"
}
